/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import Hidden from '@ion/dls/src/layout/Hidden';
import {signout} from '@/store/actions/login';
import {isAuthenticatingSelector} from '@/store/selectors/login-selectors';
import {currentPageSelector} from '@/store/selectors/nav-selectors';
import DesktopHeader from './DesktopHeader';
import MobileHeader from './MobileHeader';

interface Props {
  username: string;
}

/**
 * @ResponsiveHeader
 */
const ResponsiveHeader = ({username}: Props) => {
  const dispatch            = useDispatch();
  const isLoggingOut       = useSelector(isAuthenticatingSelector);
  const currentPage        = useSelector(currentPageSelector);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [toggle, setToggle]         = useState(false);

  const onHelp = function() {
  };

  const onLogout = function() {
    dispatch(signout());
  };

  const handleClickOpen = function() {
    setDialogOpen(true);
  };

  return (
    <div>
      <Hidden show='desktop'>
        <DesktopHeader username={username}
          onHelp={onHelp}
          onLogout={onLogout}
          isLoggingOut={isLoggingOut}
          handleClickOpen={handleClickOpen}
          dialogOpen={dialogOpen}
          setDialogOpen={setDialogOpen} />
      </Hidden>
      <Hidden show='mobile'>
        <MobileHeader username={username}
          onHelp={onHelp}
          onLogout={onLogout}
          isLoggingOut={isLoggingOut}
          handleClickOpen={handleClickOpen}
          dialogOpen={dialogOpen}
          setDialogOpen={setDialogOpen}
          currentPage={currentPage} />
      </Hidden>
    </div>
  );
};
export default ResponsiveHeader;
